import React from 'react'
import { Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DeparturesPlaceholderIcon = createIcon({
    viewBox: '0 0 76 62',
    path: (
        <>
            <Path
                fillRule='nonzero'
                stroke='currentColor'
                strokeWidth={0.5}
                fill='currentColor'
                d='M61.797 6.685c-1.534 0-2.673.238-4 .79a.75.75 0 0 0-.047.024l-12.884 6.07-14.883-3.884a.748.748 0 0 0-.419 0l-8.93 2.977c-.577.18-.626 1.159-.07 1.395 0 0 6.722 3.069 11.651 5.465l-12.093 5.675-5.628-2.814a.752.752 0 0 0-.535-.047s-7.534 2.258-7.654 2.34a.743.743 0 0 0-.173 1.061c.05.067 8.944 8.948 8.944 8.948.014.019.031.029.046.047 1.192 1.44 3.056 1.716 4.256 1.72 1.004 0 2.244-.288 3.279-.813l.046-.024 13.559-6.093-3.489 20.93c-.092.525.533 1.022 1.024.815l7.441-2.977a.753.753 0 0 0 .396-.396L52.68 22.127l13.907-6.581v-.024c.801-.4 1.603-.92 2.233-1.511.63-.592 1.163-1.246 1.163-2.117 0-.911-.532-1.587-.954-2.023-1.52-1.572-4.02-3.186-7.232-3.186zm0 1.489c2.704 0 4.85 1.388 6.162 2.744.287.296.535.736.535.976 0 .141-.211.59-.697 1.047-.487.457-1.174.912-1.86 1.256l-14.14 6.697a.751.751 0 0 0-.35.373L40.402 47.034l-5.93 2.372 3.512-21.023c.102-.536-.553-1.045-1.047-.814l-14.884 6.698c-.824.425-1.97.697-2.674.697-.967-.007-2.403-.288-3.14-1.21-.01-.015-2.707-2.72-8.093-8.115l5.954-1.791 5.698 2.837a.756.756 0 0 0 .65.023l37.954-17.86c1.178-.509 2.03-.674 3.396-.674zm-31.977 3l13.14 3.279-9.024 4.255c-.03-.016-.06-.035-.093-.046-4.323-2.13-9.353-4.419-10.977-5.163l6.954-2.325z'
            />
            <Rect fill='currentColor' width={64} height={2} x={6} y={55} rx={1} />
        </>
    ),
})

DeparturesPlaceholderIcon.displayName = 'DeparturesPlaceholderIcon'
